import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, Renderer2 } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { IconField } from 'primeng/iconfield';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { InputIcon } from 'primeng/inputicon';
import { DividerModule } from 'primeng/divider';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { ChatbotService } from 'src/app/private/services/chattbot.service';
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, IconField, InputTextModule, FormsModule, InputIcon, DividerModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  @Output() widthChange = new EventEmitter<number>();
  isExpanded$ = new BehaviorSubject<boolean>(false);
  isPinned$ = new BehaviorSubject<boolean>(false);
  modules: any = [];
  permissions: any = [];
  sidebarItems: any[] = [];
  navBarItems: any[] = [];
  searchValue: string = '';
  private scriptElement: any;
  private routerSubscription!: Subscription;
  isStudentProfile: boolean = false;
  studentProfileStage: string = '';

  constructor(private router: Router,
    private localStorage: LocalStorageService,
    private renderer: Renderer2,
    private chatbotService: ChatbotService

  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.keepSubMenuOpen();
    });
    
    // check in local storage for student profile mode
    const studentProfileMode = this.localStorage.getStudentProfileMode();
    this.isStudentProfile = studentProfileMode === 'true';
    this.studentProfileStage = this.localStorage.getStudentProfileStage() || '';
    
  }

  ngOnInit() {
    this.updateWidth();
    this.keepSubMenuOpen();
    this.modules = JSON.parse(this.localStorage.getFeatureModules());
    console.log("modules", this.modules)
    this.permissions = JSON.parse(this.localStorage.getPermissions());

    this.navBarItems = [
      {
        title: "Analytics",
        icon: "pi pi-chart-line",
        route: "/main/analytics",
        subMenu: null,
        show: this.getFeatureModuleAccess('analytics') && this.getAccess('analytics')
      },
      {
        title: "Manage Leads",
        icon: "pi pi-users",
        route: "/main/leads",
        subMenu: null,
        show: this.getFeatureModuleAccess('lead') && this.getAccess('lead')
      },
      {
        title: "Registration",
        icon: "pi pi-address-book",
        route: "/main/registration",
        subMenu: null,
        show: this.getFeatureModuleAccess('registration') && this.getAccess('registration')
      },
      {
        title: "Applications",
        icon: "pi pi-file-plus",
        route: "/main/application",
        subMenu: null,
        show: this.getFeatureModuleAccess('application') && this.getAccess('application')
      },
      {
        title: "Enrollments",
        icon: "pi pi-user-plus",
        route: "/main/enrollment",
        subMenu: null,
        show: this.getFeatureModuleAccess('enrollment') && this.getAccess('enrollment')
      },
      {
        title: "Admissions",
        icon: "pi pi-id-card",
        route: "/main/admission",
        subMenu: null,
        show: this.getFeatureModuleAccess('admission') && this.getAccess('admission')
      },
      {
        title: "Students",
        icon: "pi pi-user-edit",
        route: "/main/student",
        subMenu: null,
        show: this.getFeatureModuleAccess('students') && this.getAccess('students')
        // show: true
      },
      {
        title: "Contacts",
        icon: "pi pi-address-book",
        route: "/main/contacts",
        subMenu: null,
        show: this.getFeatureModuleAccess('contact') && this.getAccess('contact')
        // show: true
      },
      {
        title : "Learning",
        icon : "pi pi-book",
        route : "/main/learning",
        subMenu : null,
        show : this.getFeatureModuleAccess('learning') && this.getAccess('learning'),
        // show: true
      },
      {
        title: "Students Profile",
        icon: "pi pi-user-edit",
        route: "/main/student/stage/profile",
        subMenu: null,
        show: this.isStudentProfile
        // show: true
      },
      {
        title: "Manage Campaigns",
        icon: "pi pi-megaphone",
        route: "/main/manage-campaign",
        subMenu: null,
        show: this.getFeatureModuleAccess('campaign') && this.getAccess('campaign')
      },
      {
        title: "Tickets",
        icon: "pi pi-ticket",
        route: "/main/manage-tickets",
        subMenu: null,
        show: this.getFeatureModuleAccess('ticket') && this.getAccess('ticket')
      },
      {
        title: "Reports",
        icon: "pi pi-chart-bar",
        route: "/main/reports",
        subMenu: null,
        show: this.getFeatureModuleAccess('report') && this.getAccess('report')
      },
      {
        title: 'Sales Mail Hub',
        icon: "pi pi-envelope",
        route: "/main/sales-mail-hub",
        subMenu: null,
        show: this.getFeatureModuleAccess('sales_mail_hub') && this.getAccess('sales_mail_hub'),
      },

      {
        title: "Dashboard",
        icon: "pi pi-chart-bar",
        route: "/main/dashboard",
        subMenu: null,
        show: false
      },
      {
        title: "Settings",
        icon: "pi pi-cog",
        route: null, // No direct route for settings
        subMenu: [
          {
            title: "Manage Dynamic Fields", route: "/main/settings/configuration-fields",
            icon: "pi pi-calendar",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'leads_field_setting')
          },
          {
            title : "Configuration Panel", route : "/main/settings/configuration-panel",
            icon : "pi pi-sliders-h",
            // show : this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'configuration_panel')
            show : true
          },
          {
            title: "Dynamic Form Builder", route: "/main/settings/form-builder",
            icon: "pi pi-file-edit",
            show: true
          },
          {
            title: "Manage Users", route: "/main/settings/configuration-users",
            icon: "pi pi-user",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'user')
          },
          {
            title: "Whatsapp Templates", route: "/main/settings/configuration-whatsapp-templates",
            icon: "pi pi-whatsapp",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'whatsapp_template')
          },
          {
            title: "Email Templates", route: "/main/settings/configuration-email-templates",
            icon: "pi pi-envelope",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'email_template')
          },
          {
            title: "Dialing Groups", route: "/main/settings/configuration-dialing-groups",
            icon: "pi pi-phone",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'dialing_group')
          },
          {
            title: "Contact Groups", route: "/main/settings/configuration-contact-groups",
            icon: "pi pi-users",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'contact_group')
          },
          {
            title: "Hostel Configuration", route: "/main/settings/hostel-configuration",
            icon: "pi pi-building",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'hostel_configuration')
          },
          {
            title: "Transport Configuration", route: "/main/settings/transport-configuration",
            icon: "pi pi-car",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'transport_configuration')
          },
          {
            title: "Scholarship Config...", route: "/main/settings/scholarship-configuration",
            icon: "pi pi-gift",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'scholarship_configuration')
          },
          {
            title: "Department Config...", route: "/main/settings/department-configuration",
            icon: "pi pi-sitemap",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'department_configuration')
          },
          {
            title: "Roll Number Config...", route: "/main/settings/roll-number-configuration",
            icon: "pi pi-id-card",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'roll_number_configuration')
            // show : true
          },
          {
            title: "Course Configuration", route: "/main/settings/course-configuration",
            icon: "pi pi-book",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'course_configuration')
          },
          {
            title: "Batch Configuration", route: "/main/settings/batch-configuration",
            icon: "pi pi-list",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'batch_configuration')
          },
          {
            title: "Academic Year", route: "/main/settings/academic-year-configuration",
            icon: "pi pi-calendar",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'academic_year')
          },
          {
            title: "Fees Configuration", route: "/main/settings/configuration-fees",
            icon: "pi pi-money-bill",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'fee_configuration')
          },
          {
            title: "Pipeline Configuration", route: "/main/settings/pipeline-configuration",
            icon: "pi pi-sliders-h",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'pipeline_configuration')
            // show: true
          },
          {
            title: "Domain Authentication",
            route: "/main/settings/configuration-domain-authentication",
            icon: "pi pi-shield",
            show: this.getFeatureModuleAccess('setting') && this.getfeatureAccess('setting', 'domain_authentication')
          }
        ],
        isOpen: false, // Track if submenu is open
        show: this.isStudentProfile ? false : true
      },
      {
        title: "Dashboard",
        icon: "pi pi-chart-bar",
        route: "/main/dashboard",
        subMenu: null,
        show: false
      }
    ];

    this.sidebarItems = this.navBarItems;

    // make sidebar item open true if it is active
    this.sidebarItems.forEach(item => {
      if (item.subMenu) {
        item.isOpen = item.subMenu.some((sub: any) => this.router.url.includes(sub.route));
      }
    })

    this.checkUrl(this.router.url);


    // check counsellor_bot permission
    let hasChatbotPermission = this.getFeatureModuleAccess('counsellor_bot')
    if (hasChatbotPermission) {
      this.routerSubscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: any) => {
          this.checkAndToggleBot(event.url);
        });
    }

  }

  checkUrl(url: string) {
    let hasChatbotPermission = this.getFeatureModuleAccess('counsellor_bot')

    if (!hasChatbotPermission) {
      return;
    }

    if (url.includes('/leads') || url.includes('/application') || url.includes('/registration')) {
      this.chatbotService.addChatbot(this.botId);
    }
  }

  checkAndToggleBot(url: string): void {

    let hasChatbotPermission = this.getFeatureModuleAccess('counsellor_bot')
    if (!hasChatbotPermission) {
      return;
    }

    if (url.includes('/leads') || url.includes('/application') || url.includes('/registration')) {
      this.chatbotService.addChatbot(this.botId);
    } else {
      this.chatbotService.removeChatbot();
    }
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private botId = 'f989510d-7e1f-4b8a-9fb6-cf922b495e5e';

  private loadScript() {
    let chatScript = document.createElement("script");
    chatScript.type = "text/javascript";
    chatScript.async = true;
    chatScript.src = "https://demo-bot.gravitasai.com/assets/widget.js";
    chatScript.setAttribute('data-ai', this.botId);
    document.body.appendChild(chatScript);
  }



  togglePin() {
    this.isPinned$.next(!this.isPinned$.value);
    if (this.isPinned$.value) {
      this.isExpanded$.next(true);
    }
    this.updateWidth();
  }

  expandSidebar() {
    if (!this.isPinned$.value) {
      this.isExpanded$.next(true);
    }
    // this.updateWidth();
  }

  collapseSidebar() {
    if (!this.isPinned$.value) {
      this.isExpanded$.next(false);
    }
    // this.updateWidth();
  }

  toggleSubMenu(item: any) {
    if (item.subMenu) {
      item.isOpen = !item.isOpen;
    }
  }

  keepSubMenuOpen() {
    this.sidebarItems.forEach(item => {
      if (item.subMenu) {
        item.isOpen = item.subMenu.some((sub: any) => this.router.url.includes(sub.route));
      }
    });
  }

  private updateWidth() {
    // const width = this.isExpanded$.value || this.isPinned$.value ? 210 : 54;
    const width = this.isPinned$.value ? 210 : 54;
    this.widthChange.emit(width);
  }

  getFeatureModuleAccess(module_name: any) {
    console.log(this.modules)
    console.log(this.modules.includes(module_name))
    return (this.modules.includes(module_name) ? true : false);
  }

  getAccess(module_name: any) {
    console.log("pemision", this.permissions)
    let result = this.permissions.filter((item: any) => {
      return item.module_name == module_name && item.active == true;
    })
    console.log("gaurav", result[0])
    return (result[0]) ? true : false;
    //return true;
  }

  search() {
    console.log(this.searchValue)

    if (this.searchValue == '') {
      this.sidebarItems = this.navBarItems;
      return;
    }

    let newSidebarItems = this.sidebarItems.filter((item: any) => {
      if (item.title.toLowerCase().includes(this.searchValue.toLowerCase()) || (item.subMenu && item.subMenu.some((sub: any) => sub.title.toLowerCase().includes(this.searchValue.toLowerCase())))) {
        return item;
      }
    })

    console.log(newSidebarItems)

    this.sidebarItems = newSidebarItems;

  }

  getfeatureAccess(module_name: any, feature_name: any) {
    //console.log(this.permissions)
    let feature = [];
    let module = [];
    module = this.permissions.filter((item: any) => {
      return item.module_name == module_name;
    })
    if (module.length > 0) {
      feature = module[0]['features'].filter((item: any) => {
        return item.name == feature_name && item.active == true;
      })
    }

    console.log("gaurav 123 ", feature[0])
    console.log("module 123", module[0])

    return (module[0] && feature[0]) ? true : false;

  }
}
